import React from "react";

import styles from "./SmartGradientDef.module.scss";

// The paint server every sparkle glyph fills from, since a FontAwesome path cannot take a CSS
// gradient. Mounted once by App so it outlives every icon that references it — unmount it while
// one is on screen and that glyph paints black. Geometry matches chatGradient's own 135deg: corner
// to corner, in the referencing glyph's own box.
const SmartGradientDef = () => (
  <svg aria-hidden className={styles.def} focusable="false">
    <defs>
      <linearGradient id="chatSmartGradient" x1="0" x2="1" y1="0" y2="1">
        <stop className={styles.from} offset="0" />
        <stop className={styles.to} offset="1" />
      </linearGradient>
    </defs>
  </svg>
);

export default SmartGradientDef;
